import { defineMessages } from 'react-intl';


const messages = defineMessages({
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  phone: {
    id: 'Phone',
    defaultMessage: 'Phone',
  },
  email: {
    id: 'Email',
    defaultMessage: 'Email',
  },
  schedule: {
    id: 'Schedule',
    defaultMessage: 'Schedule',
  },
  address: {
    id: 'Address',
    defaultMessage: 'Address',
  },
  image: { 
    id: 'Image', 
    defaultMessage: 'Image' 
  },
  socialNetworks: {
    id: 'SocialNetworks',
    defaultMessage: 'Social Networks',
  },
  addSocialNetwork: {
    id: 'AddSocialNetwork',
    defaultMessage: 'Add Social Network',
  },
  socialNetworkType: {
    id: 'SocialNetworkType',
    defaultMessage: 'Social Network Type',
  },
  socialNetworkUrl: {
    id: 'SocialNetworkUrl',
    defaultMessage: 'Social Network URL',
  },
});


const socialNetworkSchema = (props) => ({
  title: 'Social Network',
  addMessage: props.intl.formatMessage(messages.addSocialNetwork),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['type', 'url'],
    },
  ],
  properties: {
    type: {
      title: props.intl.formatMessage(messages.socialNetworkType),
      widget: 'select',
      choices: [
        ['facebook', 'Facebook'],
        ['twitter', 'X'],
        ['instagram', 'Instagram'],
        ['youtube', 'YouTube'],
        ['whatsapp', 'WhatsApp'],
        ['bluesky', 'Bluesky'],
      ],
    },
    url: {
      title: props.intl.formatMessage(messages.socialNetworkUrl),
      widget: 'url',
    },
  },
  required: ['type', 'url'],
});


export const schema = (props) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'title',
          'description',
          'address',
          'phone',
          'email',
          'schedule',
          'image',
          'socialNetworks',
        ],
      },
    ],
    properties: {
      title: {
        title: props.intl.formatMessage(messages.title),
        widget: 'text',
      },
      description: {
        title: props.intl.formatMessage(messages.description),
        widget: 'textarea',
      },
      address: {
        title: props.intl.formatMessage(messages.address),
        widget: 'text',
      },
      phone: {
        title: props.intl.formatMessage(messages.phone),
        type: 'string',
      },
      email: {
        title: props.intl.formatMessage(messages.email),
        type: 'string',
      },
      schedule: {
        title: props.intl.formatMessage(messages.schedule),
        widget: 'text',
      },
      image: {
        title: props.intl.formatMessage(messages.image),
        widget: 'attachedimage',
      },
      socialNetworks: {
        title: props.intl.formatMessage(messages.socialNetworks),
        description: props.intl.formatMessage(messages.addSocialNetwork),
        schema: socialNetworkSchema(props),
        widget: 'object_list',
      },
    },
  };
};

export default schema;